/**
 * Logger utility for conditional logging based on environment
 * Prevents performance issues and data exposure in production
 */
class Logger {
  static isEnabled() {
    return process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG === 'true';
  }

  static info(...args) {
    if (this.isEnabled()) {
      console.info(...args);
    }
  }

  static warn(...args) {
    // Always log warnings
    console.warn(...args);
  }

  static error(...args) {
    // Always log errors
    console.error(...args);
  }

  static debug(...args) {
    if (this.isEnabled() && console.debug) {
      console.debug(...args);
    }
  }

  // For critical production logs (use sparingly)
  static production(...args) {
    console.info(...args);
  }
}

export default Logger;
